import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPointAccount, IPointAccountHistory } from "src/models/Customers/Customer.models";

interface PointAccountState {
  pointAccounts: IPointAccount[];
  pointAccountToEdit: IPointAccount | null;
  pointAccountHistorys: IPointAccountHistory[];
  pointAccountHistoryToEdit: IPointAccountHistory | null;
}

const initialState: PointAccountState = {
  pointAccounts: [],
  pointAccountToEdit: null,
  pointAccountHistorys: [],
  pointAccountHistoryToEdit: null,
};

const pointAccountSlice = createSlice({
  name: "PointAccount",
  initialState,
  reducers: {
    setPointAccountHistoryList: (state, action: PayloadAction<IPointAccountHistory[]>) => {
      state.pointAccountHistorys = action.payload;
    },
    concatListPointAccountHistory: (
      state: PointAccountState,
      action: PayloadAction<IPointAccountHistory[]>
    ) => {
      state.pointAccountHistorys = [...state.pointAccountHistorys.concat(action.payload)];
    },
    setPointAccountList: (state, action: PayloadAction<IPointAccount[]>) => {
      state.pointAccounts = action.payload;
    },
    concatListPointAccount: (
      state: PointAccountState,
      action: PayloadAction<IPointAccount[]>
    ) => {
      state.pointAccounts = [...state.pointAccounts.concat(action.payload)];
    },
    setPointAccountToEdit: (state, action: PayloadAction<IPointAccount | null>) => {
      state.pointAccountToEdit = action.payload;
    },
    addPointAccount: (state, action: PayloadAction<IPointAccount>) => {
      state.pointAccounts.push(action.payload);
    },
    updatePointAccount: (state, action: PayloadAction<IPointAccount>) => {
      let itemIndex = state.pointAccounts.findIndex(
        item => item.pointAccountId === action.payload.pointAccountId
      );
      if (itemIndex !== -1) state.pointAccounts[itemIndex] = action.payload;
    },
    deletePointAccount: (state, action: PayloadAction<number>) => {
      const newArray = state.pointAccounts.filter(
        item => item.pointAccountId !== action.payload
      );
      state.pointAccounts = newArray;
    },
  },
});

export const {
  setPointAccountList,
  setPointAccountHistoryList,
  concatListPointAccount,
  concatListPointAccountHistory,
  setPointAccountToEdit,
  addPointAccount,
  updatePointAccount,
  deletePointAccount,
} = pointAccountSlice.actions;

export default pointAccountSlice.reducer;
